import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { treeInjectionKey as a } from "./interface.js";
import s from "../../checkbox/src/Checkbox.js";
import { defineComponent as m, inject as l, h as c } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const f = m({
  name: "NTreeNodeCheckbox",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    indent: {
      type: Number,
      required: !0
    },
    right: Boolean,
    focusable: Boolean,
    disabled: Boolean,
    checked: Boolean,
    indeterminate: Boolean,
    onCheck: Function
  },
  setup(t) {
    const o = l(a);
    function n(e) {
      const {
        onCheck: r
      } = t;
      r && r(e);
    }
    function d(e) {
      n(e);
    }
    return {
      handleUpdateValue: d,
      mergedTheme: o.mergedThemeRef
    };
  },
  render() {
    const {
      clsPrefix: t,
      mergedTheme: o,
      checked: n,
      indeterminate: d,
      disabled: e,
      focusable: r,
      indent: i,
      handleUpdateValue: h
    } = this;
    return c("span", {
      class: [`${t}-tree-node-checkbox`, this.right && `${t}-tree-node-checkbox--right`],
      style: {
        width: `${i}px`
      },
      "data-checkbox": !0
    }, c(s, {
      focusable: r,
      disabled: e,
      theme: o.peers.Checkbox,
      themeOverrides: o.peerOverrides.Checkbox,
      checked: n,
      indeterminate: d,
      onUpdateChecked: h
    }));
  }
});
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tree/src/TreeNodeCheckbox.js
// module id = 1715
// module chunks = 41